<template>
  <el-dialog :title="formData.email ? '更换邮箱' : '绑定邮箱'" width="30%"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false">
    <el-form :model="formModel" :rules="formRules" ref="formRef" label-width="100px">
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="formModel.email" placeholder="请填写邮箱" />
      </el-form-item>
<!--      <el-form-item label="验证码" prop="phoneCode">-->
<!--        <el-input v-model="formModel.phoneCode" placeholder="请填写邮箱验证码">-->
<!--          <el-button slot="append" type="primary" :disabled="disSendBtn" @click="handleSendCode">{{disSendBtn?`${undisSendBtnTime}秒后重试`:"发送验证码"}}</el-button>-->
<!--        </el-input>-->
<!--      </el-form-item>-->
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('formRef')">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapActions, mapGetters } from "vuex"
  import { duplicateCheck, sendSmsByPhone, updateUserBase } from "@/api/system/user"

  export default {
      props: {
          visible: {
              type: Boolean,
              default: false
          },
          formData: {
              type: Object,
              default () {
                  return {
                      id: null,
                      email: null
                  }
              }
          }
      },
      data() {
          const checkEmail = (rule, email, callback) => {
              if (email === null || email === "") {
                  callback(new Error("请输入邮箱"));
              } else if (!/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(email)) {
                  callback(new Error("邮箱格式错误"));
              } else if (email === this.formData.email) {
                  callback(new Error("新邮箱与原邮箱相同"));
              } else {
                  // 远程验证邮箱是否存在
                  duplicateCheck({
                      id: this.formModel.id,
                      email
                  }).then(res => {
                      if (res) callback(new Error("邮箱已被其他账号绑定，请更换"));
                      callback();
                  });
              }
          };
          return {
              dialogVisible: this.visible,
              disSendBtn: false,
              undisSendBtnTime: 60,
              sendBtnTimer: null,
              formModel: Object.assign({}, this.formData),
              formRules: {
                  email: [
                      { required: true, message: '请输入邮箱', trigger: 'blur' },
                      { validator: checkEmail, trigger: 'blur' }
                  ],
                  phoneCode: [
                      { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
                      { min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" }
                  ]
              }
          }
      },
      computed: {
          ...mapGetters(['userInfo'])
      },
      watch: {
          visible(val, oldval) {
              if (val === oldval) {
                  return
              }
              this.dialogVisible = val
          },
          dialogVisible(val, oldval) {
              if (!val) {
                  this.$refs["formRef"].clearValidate()
              } else {
                  this.formModel = Object.assign({}, this.formData)
              }
              if (val === oldval) {
                  return
              }
              this.$emit('update:visible', val)
          }
      },
      methods: {
          ...mapActions(['setUserinfo']),
          handleSendCode() {
              this.$refs["formRef"].validateField("email", errMsg => {
                  if (errMsg) {
                      return
                  }
                  const { email: phone } = this.formModel
                  sendSmsByPhone(phone)
                  this.handleIntervalSendBtn()
              })
          },
          handleIntervalSendBtn() {
              // 禁用发送验证码按钮
              this.disSendBtn = true
              this.undisSendBtnTime = 60
              clearInterval(this.sendBtnTimer)
              this.sendBtnTimer = setInterval(() => {
                  if (this.undisSendBtnTime === 1) {
                      clearInterval(this.sendBtnTimer)
                      this.disSendBtn = false
                      return
                  }
                  this.undisSendBtnTime--
              }, 1000)
          },
          handleSubmit(refName) {
              const formRef = this.$refs[refName]
              formRef.validate(valid => {
                  if (!valid) {
                      return
                  }
                  const { model } = formRef
                  updateUserBase({
                      ...model,
                      // emailActivation: this.userInfo.emailActivation
                      emailActivation: 0
                  }).then(() => {
                      this.$message.success("邮箱更新成功")
                      this.dialogVisible = false
                      this.setUserinfo(Object.assign({}, this.userInfo, model))
                  })
              })
          }
      }
  }
</script>
